import { addStyles } from 'ethcss'
import { indents, mediaCSS, textSizes } from 'theme/media'
import { IStyles, grid, colors } from 'theme'

export const styles: IStyles = {
    addDeviceByCode: {
        ...grid.col,
        ...grid.justify,
        ...grid.full,
        ...grid.p_md,
    },
    addDeviceByCode__content: {
        ...grid.colCenter,
        ...grid.full,
    },
    addDeviceByCode__title: {
        display: 'block',
        width: '100%',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: textSizes.mdPlus,
    },
    addDeviceByCode__field: {
        ...grid.w20,
        [mediaCSS.tabMini]: {
            ...grid.w100,
        },
        ...grid.mb_mini,
    },
    addDeviceByCode__licenseField: {
        width: '55%',
        minWidth: 380,
        maxWidth: 520,
        [mediaCSS.tabMini]: {
            width: '100%',
            minWidth: 'unset',
            maxWidth: '100%',
        },
        ...grid.mb_mini,
    },
    addDeviceByCode__footer: {
        ...grid.row,
        ...grid.center,
    },
    addDeviceByCode__label: {
        width: '100%',
        textTransform: 'uppercase',
        textAlign: 'center',
        fontSize: textSizes.md,
    },
    addDeviceByCode__input: {
        textAlign: 'center',
        fontSize: textSizes.normalPlus,
    },
    addDeviceByCode__info: {
        width: '60%',
        paddingTop: indents.mini,
        textAlign: 'center',
        [mediaCSS.tabMini]: {
            width: '100%',
        },
    },
    license__info: {
        width: '100%',
        paddingTop: indents.mini,
        textAlign: 'center',
    },
    license__label: {
        width: '100%',
        textAlign: 'center',
        fontSize: textSizes.md,
    },
    licenseOption: {
        padding: 6,
        borderRadius: 5,
        backgroundColor: 'transparent',
        width: '100%',
        transition: 'background-color 0.3s',

        '&:hover': {
            backgroundColor: '#E9ECF1',
        },
    },
    licenseOptionRow: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 16,

        [mediaCSS.tabMini]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 4,
        },
    },
    licenseOptionName: {
        fontWeight: 'bold',
        flex: 1,
        minWidth: 0,

        [mediaCSS.tabMini]: {
            whiteSpace: 'normal',
            wordBreak: 'break-word',
        },
    },
    licenseOptionDesc: {
        borderRadius: 5,
        backgroundColor: '#F2F4F7',
        fontWeight: 'normal',
        whiteSpace: 'nowrap',
        flexShrink: 0,

        [mediaCSS.tabMini]: {
            whiteSpace: 'normal',
        },

        span: {
            color: colors.blueAccent,

            span: {
                color: 'rgba(37, 130, 224, 0.50)',
            },
        },
    },
    licenseHeaderDesc: {
        borderRadius: 5,
        backgroundColor: 'transparent',
        fontWeight: 'normal',
        whiteSpace: 'nowrap',
        flexShrink: 0,

        [mediaCSS.tabMini]: {
            whiteSpace: 'normal',
        },

        span: {
            color: colors.blueAccent,

            span: {
                color: 'rgba(37, 130, 224, 0.50)',
            },
        },
    },
    licenseSelected: {
        width: '100%',
        textAlign: 'left',
    },
    licenseDropdown: {
        width: '100%',
    },
    licenseDropdownButton: {
        justifyContent: 'flex-start !important',
        textAlign: 'left !important',
        height: 'auto !important',
        minHeight: 40,

        [mediaCSS.tabMini]: {
            alignItems: 'flex-start !important',
            paddingTop: '8px !important',
            paddingBottom: '8px !important',
        },
    },
    addDeviceByCode__button: {
        marginRight: indents.mini,
    },
    addDeviceByCode_noVacant: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        width: '100%',
    },
    noLicensesLeft: {
        display: 'flex',
        marginTop: 14,
        color: colors.notificationRed,

        span: {
            marginLeft: 10,
            fontSize: 11,
        },
    },
}

addStyles(styles)
